var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""},on:{"click":_vm.toggleColorMode}},[_c('v-card-text',{staticClass:"px-5 py-0 text-center"},[(_vm.isDark)?_c('small',{staticClass:"overline"},[_vm._v("MODO CLARO")]):_c('small',{staticClass:"overline"},[_vm._v("MODO OSCURO")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }